module.exports = __webpack_public_path__ + "img/Box-5.c83f932d.png";